import baseUrl from "services/api";
import {
	FindClientsSallesCashParms,
  FindSallesCardsTotalTypes,
  FindTopClientsSallesParms,
  ResponseFindClientsSallesCashTypes,
  ResponseFindTopClientsSalles,
} from "types/salles";

interface BuscaTopClientesVendasProps {
  dias: number;
  prioridade: string;
}

interface BuscaValoresNumerariosProps {
  dias: number;
}

export async function BuscaTopClientesVendas(
  params: BuscaTopClientesVendasProps
) {
  const respose = await baseUrl.get(
    `vendas/clientesVendas?dias=${params.dias}&prioridade=${params.prioridade}`
  );

  return respose.data;
}

export async function FindTopSellesGraphicClientsFunction(
  params: FindTopClientsSallesParms
): Promise<ResponseFindTopClientsSalles[]> {
  const respose = await baseUrl.get(`vendas/clientesVendas`, {
    params: params,
  });

  return respose.data;
}

export async function FindTopCashTypesFunctions(
  params: FindClientsSallesCashParms
): Promise<ResponseFindClientsSallesCashTypes[]> {
  const respose = await baseUrl.get(`vendas/clientesVendasNumerarios`, {
    params: params,
  });

  return respose.data;
}

export async function FindCardsTotalSallesFunction(): Promise<FindSallesCardsTotalTypes> {
  const response = await baseUrl.get("vendas/cardsVendas");

  return response.data;
}

export async function VendasCards() {
  const response = await baseUrl.get("vendas/cardsVendas");

  return response.data;
}

export async function BuscaValoresNumerarios(
  parms: BuscaValoresNumerariosProps
) {
  const response = await baseUrl.get(
    `infoCliente/vendasNumerario?dias=${parms.dias}`
  );

  return response.data;
}
